import React from "react";
import {
  ArrowUpDown,
  Brain,
  Clock,
  Crown,
  History,
  LayoutGrid,
  Radio,
  Sparkles,
} from "lucide-react";
import AdminFiltersRail, {
  AdminFilterSection,
  AdminNavFilterItem,
} from "../components/AdminFiltersRail";
import { ADMIN_PREDICTION_SORT_ICONS } from "../utils/adminDeskIcons";
import { PREDICTION_DESK_VIEWS, PREDICTION_SORT_OPTIONS } from "./constants";

const DESK_ICONS = {
  all: LayoutGrid,
  upcoming: Sparkles,
  live: Radio,
  past: History,
  premium: Crown,
};

export default function AdminPredictionsFiltersRail({
  desk,
  sortKey,
  summary,
  resultCount,
  onDeskChange,
  onSortChange,
  onClear,
  activeCount,
  compact,
  onClose,
}) {
  const deskCounts = {
    upcoming: summary?.upcoming,
    live: summary?.live,
    past: summary?.past,
    premium: summary?.premium,
  };

  const summaryCopy = [
    resultCount != null ? `${resultCount} tip${resultCount === 1 ? "" : "s"} in view` : null,
    activeCount ? `${activeCount} filter${activeCount === 1 ? "" : "s"} on` : null,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <AdminFiltersRail
      title="Predictions desk"
      subtitle="Tips · fixtures · premium"
      deskIcon={Brain}
      compact={compact}
      onClose={onClose}
      activeCount={activeCount}
      onClear={onClear}
      summaryCount={resultCount ?? summary?.total}
      summaryCopy={summaryCopy || undefined}
    >
      <AdminFilterSection label="Desk" labelIcon={Brain}>
        {PREDICTION_DESK_VIEWS.map((v) => (
          <AdminNavFilterItem
            key={v.id}
            active={desk === v.id}
            onClick={() => onDeskChange(v.id)}
            icon={DESK_ICONS[v.id]}
            label={v.label}
            hint={v.hint}
            count={deskCounts[v.id] ?? null}
            countTone={v.id === "live" && summary?.live ? "warn" : undefined}
            urgent={v.id === "live" && summary?.live > 0}
          />
        ))}
      </AdminFilterSection>

      <AdminFilterSection label="Sort" labelIcon={ArrowUpDown}>
        {PREDICTION_SORT_OPTIONS.map((opt) => (
          <AdminNavFilterItem
            key={opt.value}
            active={sortKey === opt.value}
            onClick={() => onSortChange(opt.value)}
            icon={ADMIN_PREDICTION_SORT_ICONS[opt.value] || Clock}
            label={opt.label}
          />
        ))}
      </AdminFilterSection>
    </AdminFiltersRail>
  );
}
